import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import MergeAddField from './MergeAddField'
import MergeInput from './Inputs/MergeInput'

import AlertPopup from '../../components/AlertPopup'

class MergeSteps extends Component {

    state = {
        steps: [],
        properties: {}
    }

    constructor() {
        super()

        this.onChange = this.onChange.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.addMergeField = this.addMergeField.bind(this)
    }

    componentDidMount() {
        if (this.props.path) {
            this.loadJson();
        }

        if (this.props.value) {
            const steps = this.props.value.map(step => {
                return{
                    "id": step.id,
                    "name": step.name,
                    "type": "mergeInput",
                    "values": step.values
                }
            })
            this.setState(({ steps }))
        }
    }


    addMergeField(fieldId, typeId, name) {
        let steps = this.state.steps
        let values = {}

        for (let i = 0; i < this.props.inputTypes.length; i++) {
            const inputType = this.props.inputTypes[i];
            var field = inputType.fields.find(a => a.id === fieldId)
            if (field) {
                const valueKey = inputType.blockId
                values[valueKey] = `{{${field.id}:${field.typeId}:${field.dataType}}}`
            } else {
                field = inputType.fields.find(a => a.name === name)
                if (field) {
                    const valueKey = inputType.blockId
                    values[valueKey] = `{{${fieldId}:${typeId}:${field.dataType}}}`
                }
            }
        }

        steps.push({
            "id": fieldId,
            "name": name,
            "type": "mergeInput",
            "values": values
        })

        this.setState({ steps }, () => { this.props.onChange(steps) })
    }

    onDelete(step) {
        //Check if the field is used in the connected blocks
        const block = this.props.block
        const childrenConnections = this.props.workflow.connections.filter(a=>a.from === block.id)
        const fields = this.getFieldsUsedInChildrenParams(this.props.workflow, childrenConnections)
        if (fields && fields.includes(step.id)) {
            this.setState({ deleteAlert:true })
        } 
        else {
            let steps = this.state.steps.filter(a => a.id !== step.id)

            this.setState({ steps }, () => { this.props.onChange(steps) })
        }
    }

    //TODO : Combine with server
    getFieldsUsedInChildrenParams = (workflow, childrenConnections) => {
        let fields = []
    
        for (let index = 0; index < childrenConnections.length; index++) {
            const childrenConnection = childrenConnections[index]
    
            const childBlock = workflow.blocks.find(a => a.id === childrenConnection.to)
    
            if (childBlock.action) {
                if (childBlock.action.id === "merge") {
                    this.fillFieldsUsedInMerge(childBlock.params.merge, childrenConnection.from, fields)
                } else if (childBlock.params) {
                    this.fillFieldsUsedInParams(childBlock.params, fields)
                }
            }
        }
    
        return fields
    }
    
    fillFieldsUsedInParams = (params, fields) => {
        Object.entries(params).forEach(([stepId, values]) => this.fillFieldsUsedInValues(values, fields));
    }
    
    fillFieldsUsedInMerge = (mergeFields, blockId, fields) => {
        for (let i = 0; i < mergeFields.length; i++) {
            const mergeField = mergeFields[i];
            this.fillFieldsUsedInValues(mergeField.values[blockId], fields)
        }
    }
    
    fillFieldsUsedInValues = (values, fields) => {
        if (values) {
            const valueType = typeof values
            if (valueType === 'object') {
                Object.entries(values).forEach(([key, value]) => {
                    this.fillFields(value, fields)
                });
            } else if (valueType === 'string') {
                this.fillFields(values, fields)
            }
        }
    }
    
    fillFields = (value, fields) => {
        const reg = /([^{]*)({{([^}]+):([^}]+)}})([^{]*)/g
        let result
        while ((result = reg.exec(value)) !== null) {
            const id = result[3]
    
            if (!fields.includes(id)) {
                fields.push(id)
            }
        }
    }

    onChange(stepId, name, values) {
        let steps = this.state.steps
        let step = steps.find(a => a.id == stepId);
        step.values = values
        this.setState({ steps }, () => { this.props.onChange(steps) })
    }

    render() {
        if (!this.props.inputTypes) {
            return ""
        }
        const { t } = this.props;

        const colClassName = "col-" + (12 / (this.props.inputTypes.length + 1))
        return <div>
            {this.state.steps.length > 0 ?
                <div className="row">
                    {this.props.inputTypes.map(type => <div className={colClassName} key={type.id}>{type.name}</div>)}
                    <div className={colClassName}>Result</div>
                </div>
                : ""}
            {this.state.steps.map(step => <MergeInput key={step.id} step={step} onDelete={this.onDelete} inputTypes={this.props.inputTypes} onChange={this.onChange} />)}
            <MergeAddField onSelect={this.addMergeField} key="mergeAdd" steps={this.state.steps} />
            <AlertPopup title={t("lbl_warning")} alertText={t("lbl_fieldinuse")} buttonText={t("btnclose")} 
                show={this.state.deleteAlert} onHide={ () => this.setState({ deleteAlert:false }) }/>
        </div>
    }
}

export default withTranslation()(MergeSteps)